import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import axios from 'axios';

import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import MessageSentModal from '../../../project-request/components/project-request-form/message-sent-modal/MessageSentModal';
import sendRequest from '../../../service/sendRequest';

import scss from './RequestFullAccessButton.module.scss';

function RequestFullAccessButton() {
  const { t } = useTranslation('demoAdImages');

  const [isOpenMessageSentModal, setIsOpenMessageSentModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const password = useSelector((state) => state.demoRecreate.password);

  const handleOpenMessageSentModal = async () => {
    setIsLoading(true);

    try {
      await sendRequest(() => axios.post(`/api/consumer/id8/demo/recreate/request/full/access?password=${password}`));
      setIsOpenMessageSentModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseMessageSentModal = () => {
    setIsOpenMessageSentModal(false);
  };

  return (
    <>
      <CommonButton
        styleColor={BUTTON_STYLES.PRIMARY}
        onClick={handleOpenMessageSentModal}
        maxWidth={192}
        isLoading={isLoading}
        LeftIcon={<Icon icon={ICONS.Scout} disableCommonStyles disableCommonColors className={scss.id8Icon} />}>
        {t('requestFullAccess')}
      </CommonButton>

      <MessageSentModal isOpen={isOpenMessageSentModal} onClose={handleCloseMessageSentModal} />
    </>
  );
}

export default RequestFullAccessButton;
